import { loadRuntimeConfig } from '@nucleus-commerce/admin-kit/config';

/** Validated once at import time; a bad deploy fails loudly before anything renders. */
export const config = loadRuntimeConfig({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  apiMode: import.meta.env.VITE_API_MODE,
  monitoringDsn: import.meta.env.VITE_MONITORING_DSN,
});
